export const iconsEmployee: Record<string, string> = {
  High: '✈️',
  'Top (10X)': '🚀',
  Mismatch: '⚠️',
}
